import { useQuery } from "@tanstack/react-query";
import {
  getAllGame,
  getFreeGame,
  getGameDetail,
  getMostWishlistGame,
} from "../../../apis/game/game";
import { queryContants } from "../../../constant";
import { getAllRamdomGame } from "../../../apis/orders/orders";
import { useInfinitePageQuery } from "../infinitePage.query";

export const useAllGameQuery = (pageSize, searchFilterParams, sort) => {
  return useInfinitePageQuery({
    queryKey: [queryContants.GET_GAME, JSON.stringify(searchFilterParams)],
    queryFn: (props) => getAllGame(props, pageSize, searchFilterParams, sort),
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000, // 5 minutes - works with or without authentication
  });
};

export const useGetGameDetailQuery = (id) => {
  return useQuery({
    queryKey: [queryContants.GET_GAME_DETAIL, id],
    queryFn: () => getGameDetail(id),
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000, // 5 minutes - works with or without authentication
  });
};

export const useGetAllRamdomGameQuery = (isUser) => {
  const accessToken = localStorage.getItem("accessToken");
  return useQuery({
    queryKey: [queryContants.GET_ALL_RAMDOM_GAME],
    queryFn: getAllRamdomGame,
    enabled: !!accessToken && isUser,
  });
};

export const useGetMostWishListGameQuery = () => {
  return useQuery({
    queryKey: [queryContants.GET_MOST_WISHLIST_GAME],
    queryFn: getMostWishlistGame,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000, // 5 minutes
    // Always enabled, works with or without authentication
  });
};

export const useGetFreeListGameQuery = () => {
  return useQuery({
    queryKey: [queryContants.GET_FREE_GAME],
    queryFn: getFreeGame,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000, // 5 minutes
    // Always enabled, works with or without authentication
  });
};
